export default "__VITE_ASSET__DXJM14gQ__"